import {Grid,} from "@material-ui/core";
import { Star } from "@material-ui/icons";
import React, { Component } from "react";
import 'react-input-range/lib/css/index.css';
import { request } from "../../../api-client";
import {setPageTitle} from "../../../api-client/core/authentication/utils";
import BloomSpinner from "../../../assets/img/bloom_spinner_grey.gif";
import ContentCreationPlayer from "../../../components/Letflow/ContentCreationPlayer";
import CreationItem from "../../../components/Letflow/CreationItem";
import HomeSearchInput from "../../../components/Letflow/HomeSearchInput";
import localization from "../../../config/localization";
import EventManager, { events } from "../../../utils/EventManager";
import "../Home.css";
import "./index.css";
import ShareOnSocials from "../../../components/Letflow/ShareOnSocials";

class FavoritesContentCreation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contentCreations: [],
      pageReady: false,
      showContentCreationDialog: false,
      currentPlayingContent: {},
      search: "",
      showShareDialog: false,
      sharingCreation: 1,
      shareToken: "",
    }
  }

  componentDidMount = () => {
    setPageTitle(localization.get('title.favorites'))
    document.getElementsByTagName('html')[0].scrollTop = 0;
    request.user.favorites()
      .then((user) => {
        let creations = user.contentCreationsFavorites.map(c => {
          return {...c, favorite: true}
        });
        this.setState({
          contentCreations: creations,
          unfilteredContentCreations: creations,
        }, () => this.setState({pageReady: true}))
      })

    EventManager.getInstance().subscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().subscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)
  }

  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_BUTTON_PRESS, this.addToFavorites)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, this.removeFromFavorites)
  }

  onFavorite = (creation) => {
    this.removeFromFavorites(creation.id);
  }

  removeFromFavorites = id => {
    this.setState(state => ({
      ...state,
      unfilteredContentCreations: state.unfilteredContentCreations.filter(creation => creation.id !== id)
    }), this.refreshSearch)
    request.contentCreationFavorite.remove(id);
  }

  refreshSearch = () => {
    let value = this.state.search;
    this.setState({
      contentCreations: this.state.unfilteredContentCreations.filter(i =>
        i.title.toLowerCase().includes(value.toLowerCase()) ||
        (i.synonyms && i.synonyms.toLowerCase().includes(value.toLowerCase()))
      )
    })
  }

  clearCurrentPlayingContent = () => {
    this.setState({showContentCreationDialog: false, hasPrev: false, hasNext: false, currentIndex: null, currentPlayingContent: {}})
  }

  setCurrentPlayingContent = (index) => {
    let hasPrev = index > 0 ;
    let hasNext = index < (this.state.contentCreations.length - 1);
    this.setState({showContentCreationDialog: true, currentPlayingContent: this.state.contentCreations[index], hasPrev: hasPrev, hasNext: hasNext, currentIndex: index})
  }
  
  render = () => {

    if (!this.state.pageReady){
      return (
        <div style={{ height: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}>
          <img style={{width: 100, height: 100, marginTop: "calc(43vh - 30px)"}} src={BloomSpinner} alt="Loading logo"/>
        </div>
      )
    } else {
      return (
        <div className="favorites-category-container">
          <ShareOnSocials
            show={this.state.showShareDialog}
            handleClose={() => this.setState({showShareDialog: false})}
            url={`${window.location.protocol}//${window.location.hostname}/public/content_creations/${this.state.shareToken}`}
            darkMode={true}
            shareToken={this.state.shareToken}
          />
          <ContentCreationPlayer
            show={this.state.showContentCreationDialog}
            onNextArrow={this.state.hasNext ? () => this.setCurrentPlayingContent(this.state.currentIndex+1) : null}
            onPrevArrow={this.state.hasPrev ? () => this.setCurrentPlayingContent(this.state.currentIndex-1) : null}
            currentContentCreation={this.state.currentPlayingContent}
            handleClose={() => this.clearCurrentPlayingContent()}
          />
          <HomeSearchInput
            value={this.state.search}
            placeholder="favorites.search_creations"
            onSearch={value =>
              this.setState({search: value}, this.refreshSearch)
            }
          />
          <div class="favorites-section-title">
            <div style={{textTransform: 'uppercase', display: 'flex', alignItems: 'center', fontSize: 18, fontWeight: 'bold', lineHeight: '36px', marginBottom: '20px'}}><Star style={{marginRight: 5, fontSize: 18}}/>{localization.get("my_favorites")}</div>
          </div>
          <Grid container fullWidth>
            {this.state.contentCreations.map((creation, key) =>
              <Grid key={key} xs={12} sm={6} md={4} lg={3} xl={3} item style={{padding: 10, width: "100%"}}>
                <CreationItem
                  contentCreation={creation}
                  onFavorite={() => this.onFavorite(creation)}
                  onPlay={() => this.setCurrentPlayingContent(key)}
                  onShare={id => request.contentCreation.share(id)
                    .then(response => this.setState({
                      showShareDialog: true,
                      shareToken: response.code
                    }))
                  }
                />
              </Grid>
            )}
          </Grid>

          {(this.state.contentCreations.length === 0) &&
            <div
              style={{
                float: "left",
                position: "relative",
                width: "100%",
                textAlign: "center",
                marginTop: "30px",
                fontSize: "20px",
                padding: "40px"
              }}>{localization.get("favorites.no_result")}</div>
          }

        </div>
      )
    }
  }
}

export default FavoritesContentCreation;
